<template>
  <div v-if="results !== null">
    <div v-if="results.length > 0">
      <div
        id="hearingTraningLevel"
        ref="hearingTraningLevel"
        class="chart"
      >
      </div>
    </div>
    <div v-else class="w-100 text-center pt-3">
      <p class="is-bold">Sem Resultados</p>
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated' // eslint-disable-line
am4core.useTheme(am4themes_animated)

export default {
  props: {
    results: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      chart: null,
    }
  },
  mounted: function () {
    this.chart = am4core.create('hearingTraningLevel', am4charts.XYChart)
    this.updateChart()
  },
  methods: {
    updateChart: function () {
      this.chart.data = this.results

      // Create axes
      let xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
      xAxis.dataFields.category = 'completed_at'

      let valueAxis1 = this.chart.yAxes.push(new am4charts.ValueAxis())
      valueAxis1.title.text = this.$t('accounts.volume')
      valueAxis1.numberFormatter = new am4core.NumberFormatter()
      valueAxis1.numberFormatter.numberFormat = '#.%'
      valueAxis1.min = 0
      valueAxis1.max = 1

      let valueAxis2 = this.chart.yAxes.push(new am4charts.ValueAxis())
      valueAxis2.title.text = this.$t('accounts.correct_answers')
      valueAxis2.renderer.opposite = true
      valueAxis2.renderer.grid.template.disabled = true
      valueAxis2.min = 0
      valueAxis2.max = 10

      // Create series
      let series1 = this.chart.series.push(new am4charts.ColumnSeries())
      series1.dataFields.valueY = 'word_volume'
      series1.dataFields.categoryX = 'completed_at'
      series1.yAxis = valueAxis1
      series1.name = this.$t('accounts.hearing_training_word_volume')
      series1.tooltipText = '[font-size: 14]{name}: {valueY.formatNumber("#.%")}'
      series1.fill = this.chart.colors.getIndex(0)
      series1.strokeWidth = 0
      series1.clustered = false
      series1.columns.template.width = am4core.percent(40)
      series1.columns.template.maxWidth = 30
      series1.columns.template.fill = am4core.color('#40c4a9')

      let series2 = this.chart.series.push(new am4charts.ColumnSeries())
      series2.dataFields.valueY = 'noise_volume'
      series2.dataFields.categoryX = 'completed_at'
      series2.yAxis = valueAxis1
      series2.name = this.$t('accounts.hearing_training_noise_volume')
      series2.tooltipText = '[font-size: 14]{name}: {valueY.formatNumber("#.%")}'
      series2.fill = this.chart.colors.getIndex(0).lighten(0.5)
      series2.strokeWidth = 0
      series2.clustered = false
      series2.toBack()
      series2.columns.template.maxWidth = 60
      series2.columns.template.fill = am4core.color('#94e1d4')

      let series3 = this.chart.series.push(new am4charts.LineSeries())
      series3.dataFields.valueY = 'correct_answers'
      series3.dataFields.categoryX = 'completed_at'
      series3.name = this.$t('accounts.correct_answers')
      series3.stroke = am4core.color('#6f6f6f')
      series3.strokeWidth = 2
      series3.tensionX = 0.7
      series3.yAxis = valueAxis2
      series3.tooltipText = '[font-size: 12]{categoryX}\n[font-size: 14]{name}:\n[bold font-size: 20]{valueY}[/]'
      series3.tooltip.getFillFromObject = false
      series3.tooltip.background.fill = am4core.color('#6f6f6f')

      let bullet3 = series3.bullets.push(new am4charts.CircleBullet())
      bullet3.circle.radius = 3
      bullet3.circle.stroke = am4core.color('#6f6f6f')
      bullet3.circle.strokeWidth = 2
      bullet3.circle.fill = am4core.color('#fff')

      // Add cursor
      this.chart.cursor = new am4charts.XYCursor()
      this.chart.cursor.lineX.disabled = true
      this.chart.cursor.lineY.disabled = true
      xAxis.cursorTooltipEnabled = false
      valueAxis1.cursorTooltipEnabled = false
      valueAxis2.cursorTooltipEnabled = false

      // Add legend
      this.chart.legend = new am4charts.Legend()
      this.chart.legend.position = 'top'

      // Add scrollbar
      if (this.results.length > 10) {
        this.chart.scrollbarX = new am4charts.XYChartScrollbar()
        // chart.scrollbarX.series.push(series1)
        this.chart.scrollbarX.series.push(series3)
        this.chart.scrollbarX.parent = this.chart.bottomAxesContainer
      }

      this.chart.zoomOutButton.background.fill = am4core.color('#929292')
      this.chart.zoomOutButton.background.states.getKey('hover').properties.fill = am4core.color('#606271')
      this.chart.zoomOutButton.background.states.getKey('down').properties.fill = am4core.color('#929292')
    }
  },
  watch: {
    results: function (results) {
      this.updateChart()
    }
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
  height: 400px;
}
</style>
